const initCreateContact = () => {

    const submitButton = document.querySelector('.btn-primary');
    const contactDropdown = document.querySelector('.existing-contacts-dropdown');
    const roleDropdown = document.querySelector('.form-input');

    const checkFormValidity = () => {
        const isContactSelected = contactDropdown?.value;
        const isRoleSelected = roleDropdown?.value;
        if (submitButton) {
            submitButton.disabled = !(isContactSelected && isRoleSelected);
        }
    };

    if (submitButton && contactDropdown && roleDropdown) {
        checkFormValidity();
        contactDropdown.addEventListener('change', checkFormValidity);
        roleDropdown.addEventListener('change', checkFormValidity);
    }


    const addContactForm = document.getElementById('add-contact-form');

    document.removeEventListener('click', _handleAddContactClick);
    document.addEventListener('click', _handleAddContactClick);

    function _handleAddContactClick(e) {
        const target = e.target.closest('#add-contact-btn');
        if (!target) return;
        if (!addContactForm) return;
        addContactForm.style.display = 'block';
    }

    const btn = document.getElementById('show-contact-form-btn');
    const panel = document.getElementById('contact-form-panel');
    if (btn && panel) {
        btn.addEventListener('click', () => {
            panel.style.display = 'block';
        });
    }
};

export { initCreateContact };
